// Generated by purs version 0.13.8
"use strict";
var Data_Newtype = require("../Data.Newtype/index.js");
var Color = function (x) {
    return x;
};
var white = "#FFFFFF";
var red = "#FF0000";
var newtypeColor = new Data_Newtype.Newtype(function (n) {
    return n;
}, Color);
var gray = "#C0C0C0";
var blue = "#0000FF";
var black = "#000000";
module.exports = {
    Color: Color,
    black: black,
    white: white,
    gray: gray,
    blue: blue,
    red: red,
    newtypeColor: newtypeColor
};
